import React, { useEffect, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import styles from "./checkout.module.scss";
import {
  Gender,
  IBookingDetails,
  IBookingItem,
  SeatAvailability,
} from "../../common/types";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { API_CONSTANTS } from "../../common/constants/api";
import { SESSION_KEYS } from "../../common/constants/sessionKeys";
import { Callout } from "@radix-ui/themes";
import { InfoCircledIcon } from "@radix-ui/react-icons";

const Checkout = () => {
  const [searchParams] = useSearchParams();
  const [busId, setBusId] = useState<string | undefined | null>();
  const [validated, setValidated] = useState(false);
  const [otpValidate, setOtpValidated] = useState(false);
  const [otp, setOtp] = useState<string>("");
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [otpToken, setOtpToken] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [journeyDate, setJourneyDate] = useState<string | undefined | null>();
  const [fromLocation, setFromLocation] = useState<string | null>();
  const [toLocation, setToLocation] = useState<string | null>();
  const [bookingMessage, setBookingMessage] = useState<string>("");
  const [busRouteMappingId, setBusRouteMappingId] = useState<
    string | undefined | null
  >();
  const [bookingPrice, setBookingPrice] = useState<number>(0);
  const [bookingDetails, setBookingDetails] = useState<IBookingDetails>({
    bookingDate: "",
    bookingPrice: 0,
    busId: "",
    busRouteMappingId: "",
    fromStation: "",
    toStation: "",
    travellers: [],
    mobileNumber: "",
  });

  useEffect(() => {
    setShowOtp(false);
    console.log(
      busId,
      busRouteMappingId,
      journeyDate,
      bookingPrice,
      fromLocation,
      toLocation
    );
    if (
      busId &&
      busRouteMappingId &&
      journeyDate &&
      bookingPrice &&
      fromLocation &&
      toLocation
    ) {
      const tmpBookings: IBookingItem[] = [];
      if (sessionStorage.getItem(SESSION_KEYS.SEATING_SEATS) !== null) {
        const seatingSeats: SeatAvailability[] =
          JSON.parse(`${sessionStorage.getItem(SESSION_KEYS.SEATING_SEATS)}`) ||
          [];
        seatingSeats.forEach((seat: SeatAvailability) => {
          const bookingItem: IBookingItem = {
            age: 18,
            isLadiesSeat: seat.isLadiesSeat,
            isSleeperSeat: false,
            name: "",
            seatNumber: seat.seatNumber,
            gender: "",
            seatPrice: seat.price,
          };
          tmpBookings.push(bookingItem);
        });
      }
      if (sessionStorage.getItem(SESSION_KEYS.SLEEPING_SEATS) !== null) {
        const sleepingSeats: SeatAvailability[] =
          JSON.parse(
            `${sessionStorage.getItem(SESSION_KEYS.SLEEPING_SEATS)}`
          ) || [];
        sleepingSeats.forEach((seat: SeatAvailability) => {
          const bookingItem: IBookingItem = {
            age: 18,
            isLadiesSeat: seat.isLadiesSeat,
            isSleeperSeat: true,
            name: "",
            seatNumber: seat.seatNumber,
            gender: seat.isLadiesSeat ? Gender.FEMALE : Gender.MALE,
            seatPrice: seat.price,
          };
          tmpBookings.push(bookingItem);
        });
      }

      setBookingDetails((prevBookingDetails) => ({
        ...prevBookingDetails,
        busId: `${busId}`,
        busRouteMappingId: `${busRouteMappingId}`,
        bookingDate: `${journeyDate}`,
        bookingPrice: bookingPrice,
        fromStation: `${fromLocation}`,
        toStation: `${toLocation}`,
        travellers: [...tmpBookings],
      }));
    }
  }, [
    busId,
    busRouteMappingId,
    journeyDate,
    bookingPrice,
    fromLocation,
    toLocation,
  ]);

  const onAgeChangeHandler = (age: number, traveller: IBookingItem) => {
    traveller.age = age;
  };

  const onNameChangeHandler = (name: string, traveller: IBookingItem) => {
    traveller.name = name;
  };

  const onGenderChangeHandler = (name: Gender, traveller: IBookingItem) => {
    traveller.gender = name;
  };

  const onPhoneChangeHandler = (phone: string) => {
    setBookingDetails({
      ...bookingDetails,
      mobileNumber: phone,
    });
  };
  const sendBookingDetails = (evt: any) => {
    const form = evt.currentTarget;

    if (form.checkValidity() === false) {
      evt.preventDefault();
      evt.stopPropagation();
      setValidated(true);
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();

    setValidated(true);
    setIsLoading(true);
    axios
      .post(`${API_CONSTANTS.GENERATE_OTP}`, {
        mobileNumber: bookingDetails.mobileNumber,
      })
      //.then((res:any) => res.json())
      .then((res) => {
        console.log("OTP Response", res.data);
        if (
          res.data &&
          res.data.Status &&
          (res.data.Status === "Success" || res.data.Status === true)
        ) {
          setOtpToken(res.data.Details);
          setShowOtp(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const onOtpChangeHandler = (_otp: string) => {
    setOtp(_otp);
  };

  const initPayment = async (bookingRefId: string) => {
    const response = await axios.post(API_CONSTANTS.CREATE_ORDER, {
      amount: bookingDetails.bookingPrice,
      bookingRefId: bookingRefId,
    });
    console.log("Payment Response", response.data);
    const { amount, currency, id: order_id } = response.data;

    const options = {
      key: process.env.KEY_ID, //"rzp_test_thbnstH0Bq80hy", // Enter the Key ID generated from
      //key: process.env.KEY_ID || `rzp_test_mlz9Ji0SwsxTCX`, //"rzp_test_thbnstH0Bq80hy", // Enter the Key ID generated from the Dashboard
      amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
      currency,
      name: "Quick Bus",
      description: "Bus Ticket Transaction",
      image: "https://example.com/your_logo",
      order_id, //This is a sample Order ID. Replace with the actual Order ID generated by your backend.
      callback_url: "https://quickbusride.com/success", // Replace with your success URL
      prefill: {
        name: bookingDetails.travellers[0].name,
        //email: "sudhansurana@gmail.com",  // Add email if available
        contact: bookingDetails.mobileNumber,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
      handler: function (response: any) {
        console.log("Payment Success", response);
        axios
          .post(
            `${API_CONSTANTS.CONFIRM_BOOKING}?razorpay_order_id=${response.razorpay_order_id}&razorpay_payment_id=${response.razorpay_payment_id}&razorpay_signature=${response.razorpay_signature}`,
            {
              otpValidateRequest: { otp, details: otpToken },
              ...bookingDetails,
              bookingRefId,
            }
          )
          .then((res) => {
            console.log("Confirm Booking Response", res.data);
            if (res.data && res.data.status === "success") {
              window.location.href =
                "/success?confirmationId=" +
                res.data.confirmationId +
                "&journeyDate=" +
                journeyDate;
            } else {
              alert("Payment verification failed");
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
        /*fetch("/verify-payment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          }),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "ok") {
              window.location.href = "/payment-success";
            } else {
              alert("Payment verification failed");
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            alert("Error verifying payment");
          });*/
      },
    };
    console.log("Payment options", options);
    const razorpay = new (window as any).Razorpay(options);
    razorpay.open();
    /* razorpay.on("payment.failed", function (response: any) {
      console.error(response);
      // Handle payment failure
    }); */

    /* razorpay.on("payment.success", function (response: any) {
      console.log("Payment Success", response);
      // Handle payment success
      window.location.href = "/success";
    });
    razorpay.open(); */
  };

  const sendOtpDetails = (evt: any) => {
    const form = evt.currentTarget;
    setBookingMessage("");
    if (form.checkValidity() === false) {
      evt.preventDefault();
      evt.stopPropagation();
      setOtpValidated(true);
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();

    setOtpValidated(true);
    setIsLoading(true);
    axios
      .post(`${API_CONSTANTS.VALIDATE_OTP_AND_BOOK}`, {
        otpValidateRequest: { otp, details: otpToken },
        ...bookingDetails,
      })
      .then((res) => {
        if (res.data && res.data.success) {
          //window.location.href = "/success";
          // setBookingRefId(res.data.bookingRefId);
          initPayment(res.data.bookingRefId);
        } else {
          setBookingMessage(res.data.message);
          setShowOtp(false);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setBusId(searchParams.get("busId"));
    setJourneyDate(searchParams.get("date"));
    setBusRouteMappingId(searchParams.get("busRouteMappingId"));
    setBookingPrice(
      parseInt(sessionStorage.getItem(SESSION_KEYS.TOTAL_PRICE) || "0", 10) || 0
    );
    setFromLocation(sessionStorage.getItem(SESSION_KEYS.FROM_LOCATION_CODE));
    setToLocation(sessionStorage.getItem(SESSION_KEYS.TO_LOCATION_CODE));
  }, [searchParams]);

  return (
    <main className={`${styles.container} container`}>
      <>
        <h2 className="pb-2 border-bottom text-center text-primary my-5">
          Welcome Traveller. Please provide details.
        </h2>
        <div className="row my-3">Seat Details</div>
        {showOtp && (
          <Callout.Root color="blue">
            <Callout.Icon>
              <InfoCircledIcon />
            </Callout.Icon>
            <Callout.Text>You will receive OTP via call.</Callout.Text>
          </Callout.Root>
        )}
        <Form noValidate validated={validated} onSubmit={sendBookingDetails}>
          <div className="row my-3">
            {bookingDetails.travellers.map(
              (seat: IBookingItem, index: number) => {
                return (
                  <Col xs={12} md={6} key={index}>
                    <label className="my-3">
                      {seat.isSleeperSeat ? "Sleeper Number" : "Seat Number"}:{" "}
                      {seat.seatNumber}
                    </label>
                    <Form.Check // prettier-ignore
                      disabled
                      type="switch"
                      label="Is Ladies Seat"
                      id="disabled-custom-switch"
                      checked={seat.isLadiesSeat}
                    />
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon1">Name</InputGroup.Text>
                      <Form.Control
                        placeholder="Name"
                        aria-label="Name"
                        required={true}
                        minLength={3}
                        disabled={showOtp}
                        onChange={(e) =>
                          onNameChangeHandler(e.target.value, seat)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Provide Full Name with minimum 3 charcters.
                      </Form.Control.Feedback>
                    </InputGroup>

                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon3">Age</InputGroup.Text>
                      <Form.Control
                        placeholder="Age"
                        aria-label="Age"
                        type="number"
                        min={5}
                        required
                        disabled={showOtp}
                        max={120}
                        onChange={(e) =>
                          onAgeChangeHandler(parseInt(e.target.value, 10), seat)
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Provide Age. min 5 , max value 120
                      </Form.Control.Feedback>
                    </InputGroup>
                    <InputGroup className="mb-3">
                      <InputGroup.Text id="basic-addon4">
                        Gender
                      </InputGroup.Text>
                      <Form.Select
                        aria-label="Default select gender"
                        required
                        defaultValue={""}
                        onChange={(e) =>
                          onGenderChangeHandler(e.target.value as Gender, seat)
                        }
                      >
                        <option value="">Select Gender</option>
                        <option value={Gender.MALE}>{Gender.MALE}</option>
                        <option value={Gender.FEMALE}>{Gender.FEMALE}</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Provide Gender of traveller
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Col>
                );
              }
            )}
          </div>
          <Row className="my-3">
            <Col xs={12} md={6}>
              <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">
                  Phone Number
                </InputGroup.Text>
                <Form.Control
                  placeholder="Phone Number"
                  aria-label="Phone Number"
                  required={true}
                  minLength={10}
                  disabled={showOtp}
                  type="text"
                  pattern="^[1-9][0-9]{9}$"
                  onChange={(e) => onPhoneChangeHandler(e.target.value)}
                />
                <Form.Control.Feedback type="invalid">
                  Please Provide Phone Number.
                </Form.Control.Feedback>
                {(bookingDetails.mobileNumber as string).length < 10 && (
                  <Form.Control.Feedback className="invalid-feedback">
                    Phone number should have min 10 char.
                  </Form.Control.Feedback>
                )}
              </InputGroup>
            </Col>
          </Row>
          <button
            type="submit"
            className="btn btn-primary my-3"
            disabled={showOtp}
          >
            Request OTP
          </button>
        </Form>
        {isLoading && (
          <div className="text-center my-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        {showOtp && (
          <Form noValidate validated={otpValidate} onSubmit={sendOtpDetails}>
            <Row>
              <Col xs={12} md={6}>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">OTP</InputGroup.Text>
                  <Form.Control
                    placeholder="OTP"
                    aria-label="OTP"
                    required={true}
                    minLength={6}
                    maxLength={6}
                    pattern="^[0-9]{6}$"
                    type="text"
                    onChange={(e) => onOtpChangeHandler(e.target.value)}
                  />
                  <Form.Control.Feedback type="invalid">
                    Please Provide OTP sent to your mobile number.
                  </Form.Control.Feedback>
                  {otp.length < 6 && (
                    <Form.Control.Feedback className="invalid-feedback">
                      OTP should have min 6 char.
                    </Form.Control.Feedback>
                  )}
                </InputGroup>
              </Col>
            </Row>
            <button type="submit" className="btn btn-primary my-3">
              Submit OTP & Pay
            </button>
            {bookingMessage && (
              <Callout.Root size="3" color="red" className="my-3">
                <Callout.Icon>
                  <InfoCircledIcon />
                </Callout.Icon>
                <Callout.Text>{bookingMessage}</Callout.Text>
              </Callout.Root>
            )}
          </Form>
        )}
      </>
    </main>
  );
};

export default Checkout;
